import React from "react";
import { Flex } from "../../atoms/flex";

/**
 * Icons skeleton
 */

export const IconSkeleton = () => (
  <Flex>
    <div className="headerIconLoading" />
  </Flex>
);
